module.exports = __webpack_public_path__ + "static/media/description-logo-fr.633c0045.png";